/**
 * Observes a single DOM element and invokes the callback when the element becomes visible.
 *
 * This function sets up an IntersectionObserver to monitor the visibility of a specified DOM 
 * element. When the element's visibility exceeds the defined threshold, the callback function 
 * is executed, and the observer unobserves the element, ceasing further observations.
 *
 * @param {Element} element - The DOM element to be observed. Must be a valid HTML element.
 * @param {Function} callback - A callback function to be invoked when the element is visible.
 * @throws {Error} Throws an error if the element or callback arguments are not provided.
 */
export default function observer(element, callback) {
  if(!element) {
    throw Error("element must have a callback function as its second argument");
  }

  if(!callback) {
    throw Error("observer must have a callback function as its second argument");
  }

  function handleObserver(entries) {
    // If visible, fire away!
    if(entries[0].intersectionRatio > 0) {
      console.log({iCanSee: element });
      // Do the stuff...
      callback();

      // Cleanup observer
      eyeOfObserver.unobserve(element);
    }
  }

  const options = {
    rootMargin: "64px 0px 0px 0px",
    threshold: 0.01,
  };

  const eyeOfObserver = new IntersectionObserver(handleObserver, options);
  
  eyeOfObserver.observe(element);
}